<template>
  <div class="login-main">
    <v-img
      :src="$globalConstant.loginBackGroundLogo"
      class="login-bg-image"
    ></v-img>

    <v-row style="width: 100% !important; height: 100%">
      <v-col
        cols="7"
        class="d-none d-md-flex flex-column justify-space-between"
      >
      </v-col>
      <v-col cols="12" md="4" class="d-flex justify-center align-center">
        <div>
          <v-card
            class="px-12 py-12"
            style="max-width: 450px; min-width: 350px"
          >
            <v-card-title class="d-flex justify-center py-5">
              <h3>Welcome to DASH!</h3>
            </v-card-title>
            <v-card-title class="d-flex justify-center pt-6 pb-12">
              <h3>Sign In</h3>
            </v-card-title>
            <v-card-text>
              <v-form
                v-model="isValid"
                ref="loginForm"
                @submit.prevent="submitForm"
              >
                <v-row class="justify-center">
                  <v-col cols="pt-8 pb-6 ma-0">
                    <v-row>
                      <v-col cols="12">
                        <InputField
                          v-model.trim="userDetails.username"
                          prepend-inner-icon="mdi-account-circle"
                          name="username"
                          label="Username"
                          type="text"
                          :rules="[(v) => !!v || 'Username is required']"
                          :error-messages="formError.username"
                          @input="delete formError.username"
                        ></InputField>
                      </v-col>

                      <v-col cols="12">
                        <PasswordField
                          label="Password"
                          name="password"
                          v-model="userDetails.password"
                          :rules="[(v) => !!v || 'Password is required']"
                          :error-messages="formError.password"
                          @input="delete formError.password"
                        />
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="12" class="d-flex justify-center">
                    <v-btn
                      type="submit"
                      color="primary"
                      depressed
                      @click.prevent="submitForm"
                      :disabled="!isValid"
                      large
                    >
                      Login
                    </v-btn>
                  </v-col>
                  <v-col cols="12" class="d-flex justify-center">
                    <v-btn
                      @click="forgotPassword()"
                      text
                      type="button"
                      color="primary"
                      depressed
                      large
                      class="text-capitalize"
                    >
                      Forgot Password ?
                    </v-btn>
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>
          </v-card>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { changeTheme } from "@/utils/functions";
import { bus } from "@/main.js";

export default {
  name: "adminLogin",
  data() {
    return {
      userDetails: {},
      viewPassword: false,
      viewConfirmPassword: false,
      isValid: false,
      formError: {},
    };
  },
  methods: {
    mapHeight() {
      return window.innerWidth;
    },
    submitForm() {
      if (!this.$refs.loginForm.validate()) {
        bus.$emit("showToastMessage", {
          message: "Please correct all the errors to submit the form!",
          color: "error",
        });
        return;
      }
      this.$api.authentication
        .login(this.userDetails)
        .then((res) => {
          localStorage.setItem("user", JSON.stringify(res.data.token));
          delete res.data.token;
          let obj = { ...res.data.user_details };
          this.$wbSocket.connection();
          this.$wbSocket.notificationConnection();

          if (obj) {
            this.$permissions.setPermissions(obj);

            if (obj && obj.role) {
              if (["account_manager", "system_admin"].indexOf(obj.role) > -1) {
                this.$router.push({
                  path: `/app/admin`,
                });
              } else if (["support_user"].indexOf(obj.role) > -1) {
                this.$router.push({
                  path: `/app/support-user`,
                });
              } else if (["consignee_user"].indexOf(obj.role) > -1) {
                this.$router.push({
                  path: `/app/consignee`,
                });
              } else {
                changeTheme(
                  obj.company_details.configuration.theme,
                  this.$vuetify
                );
                this.$router.push({
                  path: `/app/client`,
                });
              }
            }
          }
        })
        .catch((err) => {
          if ("non_field_errors" in err.data) {
            if (Array.isArray(err.data.non_field_errors)) {
              for (let i = 0; i < err.data.non_field_errors.length; i++) {
                bus.$emit("showToastMessage", {
                  message: err.data.non_field_errors[i],
                  color: "error",
                });
              }
            } else {
              bus.$emit("showToastMessage", {
                message: "Something went wrong!",
                color: "error",
              });
            }
          }
          this.formError = err.data;
        });
    },
    forgotPassword() {
      this.$router.push({ name: "forgot-password" });
    },
  },
  mounted() {},
};
</script>

<style lang="scss">
.login-main {
  overflow: hidden;
  height: 100vh;
}
@media screen and (max-width: 768px) {
  .login-main {
    display: flex;
    align-items: flex-end;
    height: 100vh;
  }
}
.login-card {
  padding: 0px 48px;
  min-height: 80vh;
}

@media screen and (max-width: 1400px) {
  .login-card {
    padding: 0px 28px;
  }
}
@media screen and (max-width: 768px) {
  .login-card {
    min-height: auto;
    padding: 0px 8px 40px 8px;
    margin-bottom: 10%;
  }
}

.login-bg-image {
  position: fixed;
  height: 100vh !important;
  width: 100vw !important;
}
.login-title {
  text-align: center;
  text-transform: uppercase;
  font-weight: 100 !important;
  padding: 40px 0px;
  font-size: 38px;
  margin: 32px 0;
}

@media screen and (max-width: 1400px) {
  .login-title {
    font-size: 26px !important ;
    margin: 0px 0;
  }
}
@media screen and (max-width: 768px) {
  .login-title {
    font-size: 30px !important ;
    margin: 0px 0;
  }
}

.login-hr {
  width: 30%;
  margin-top: 24px;
  margin-bottom: 36px;
  background-color: red;
}

@media screen and (max-width: 1400px) {
  .login-hr {
    margin-top: 14px;
    margin-bottom: 6px;
  }
}
.login-logo-image {
  height: 70px;
}
.login-btn {
  text-transform: uppercase !important;
}
</style>
